import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import AddressItem from "../AddressItem";
import styles from "./AddressList.module.css";

export function AddressList({ addressInfo }) {
  // Initialize selectedAddress with the first address from addressInfo
  const [selectedAddress, setSelectedAddress] = useState(
    addressInfo[0] || null
  );

  useEffect(() => {
    // Update selectedAddress when addressInfo changes
    setSelectedAddress(addressInfo[0] || null);
  }, [addressInfo]);

  const handleSelect = (address) => {
    setSelectedAddress((prev) => (prev === address ? null : address));
  };

  return (
    <div>
      {addressInfo.map((address, index) => (
        <div
          className={`${styles.address} ${
            selectedAddress === address ? styles.selectedAddress : ""
          }`}
          key={index}
        >
          <AddressItem
            addressInfo={address}
            isSelected={selectedAddress === address}
            onSelect={() => handleSelect(address)}
          />
        </div>
      ))}
    </div>
  );
}

AddressList.propTypes = {
  addressInfo: PropTypes.arrayOf(
    PropTypes.shape({
      country: PropTypes.string,
      address1: PropTypes.string,
      address2: PropTypes.string,
      city: PropTypes.string,
      state: PropTypes.string,
      zip: PropTypes.string,
    })
  ).isRequired,
};

export default AddressList;
